/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

// Number of skeleton tiles shown per carousel row (fills the visible viewport width)
const SKELETON_TILES_PER_ROW = 5;

interface CarouselSkeletonProps {
    /** Number of skeleton carousel rows to render */
    count?: number;
}

/**
 * Placeholder shown while the initial Screens API fetch is in flight.
 * Mirrors the real carousel layout (header + tile strip) using animated
 * pulse blocks so the screen is never blank on cold load.
 */
const CarouselSkeleton: FunctionComponent<CarouselSkeletonProps> = ({ count = 3 }): JSX.Element => (
    <>
        {Array.from({ length: count }, (_, i) => (
            <div key={i} className="carousel-list-row">
                <div className="carousel carousel-skeleton">
                    <div className="carousel-inner">
                        {/* Header placeholder */}
                        <div className="carousel-header-row">
                            <div className="carousel-skeleton__header" />
                        </div>
                        {/* Tile strip placeholder */}
                        <div className="tile-list-wrapper">
                            <div className="tile-list">
                                {Array.from({ length: SKELETON_TILES_PER_ROW }, (__, j) => (
                                    <div key={j} className="carousel-skeleton__tile" />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))}
    </>
);

export default CarouselSkeleton;
